
import React, { Fragment } from 'react';

// Components
import SummaryItem from '../SummaryItem';

// Utils
import { questionsVisibility } from '@utils/miscellaneous/pageAndQuestionsVisibility';
import { toUTCAndFormat } from '@utils/dates/date.utils';
import { MM_SLASH_DD_SLASH_YYYY } from '@utils/dates/dateFormats.utils';

// Constants
import { NO_PRIOR_DATA } from '@constants/ssap/miscellaneous/miscellaneous';


const MilitaryInfo = props => {

    const {
        applyingForFinancialAssistanceIndicator,
        idx,
        isState,
        member: hhm,
        member: {
            citizenshipImmigrationStatus: {
                honorablyDischargedOrActiveDutyMilitaryMemberIndicator,
                militaryFamilyMemberIndicator
            },
            dateLastActiveTour,
            returnedFromTourOfActiveDuty,
        },
        personName,
    } = props;

    const getFormattedLocaleDate = (date, isPrevious = false) => {
        if (date === null && isPrevious) {
            return NO_PRIOR_DATA;
        }
        return toUTCAndFormat(date, MM_SLASH_DD_SLASH_YYYY);
    };

    // Q1: show for any member who met citizenship/immigration criteria
    const isQ1MemberShown = questionsVisibility.isMilitaryServiceCitizenshipImmigrationCriteriaMet({ hhm, isState, applyingForFinancialAssistanceIndicator });

    // Q2: MN only — show for members who were on the Q2 list
    // (met citizenship criteria AND were not selected on Q1)
    const isQ2MemberShown = isState?.MN
        && isQ1MemberShown
        && honorablyDischargedOrActiveDutyMilitaryMemberIndicator !== true;

    // Q3: MN only — show for members who were seeking coverage
    const isQ3MemberShown = questionsVisibility.isMilitaryServiceCoverageCriteriaMet({ hhm, isState });

    const hasQ1Answer = honorablyDischargedOrActiveDutyMilitaryMemberIndicator !== null;
    const hasQ2Answer = militaryFamilyMemberIndicator !== null;
    const hasQ3Answer = returnedFromTourOfActiveDuty !== null;

    if (!isQ1MemberShown && !isQ3MemberShown) {
        return null;
    }

    return (
        <Fragment>
            {/* Q1 — Honorably discharged / active duty */}
            {isQ1MemberShown && hasQ1Answer && (
                <SummaryItem
                    textCode='common.are_you_veteran_or_active_military'
                    value={honorablyDischargedOrActiveDutyMilitaryMemberIndicator}
                    noPriorDataValues={[null]}
                    desc={[
                        [
                            `taxHousehold.householdMember[${idx}].citizenshipImmigrationStatus.honorablyDischargedOrActiveDutyMilitaryMemberIndicator`
                        ]
                    ]}
                />
            )}

            {/* Q2 — Spouse or dependent of veteran (MN only) */}
            {isQ2MemberShown && hasQ2Answer && (
                <SummaryItem
                    textCode='common.are_spouse_dependant_of_veteran_or_active_military'
                    value={militaryFamilyMemberIndicator}
                    noPriorDataValues={[null]}
                    desc={[
                        [
                            `taxHousehold.householdMember[${idx}].citizenshipImmigrationStatus.militaryFamilyMemberIndicator`
                        ]
                    ]}
                />
            )}

            {/* Q3 — Returned from tour of active duty (MN only) */}
            {isQ3MemberShown && hasQ3Answer && (
                <Fragment>
                    <SummaryItem
                        textCode='ssap.input.legend.military_service.returned_from_tour'
                        replacements={{ personName }}
                        value={returnedFromTourOfActiveDuty}
                        noPriorDataValues={[null]}
                        desc={[
                            [
                                `taxHousehold.householdMember[${idx}].returnedFromTourOfActiveDuty`,
                            ]
                        ]}
                    />
                    {returnedFromTourOfActiveDuty && dateLastActiveTour !== null && (
                        <SummaryItem
                            textCode='ssap.input.label.military_service.last_tour_end'
                            value={getFormattedLocaleDate(dateLastActiveTour)}
                            desc={[
                                [
                                    `taxHousehold.householdMember[${idx}].dateLastActiveTour`,
                                    getFormattedLocaleDate,
                                    [true]
                                ]
                            ]}
                        />
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

export default MilitaryInfo;
